import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AuthService } from './auth.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private authService = inject(AuthService)
  private router = inject(Router)

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const returnUrl = state.url
    return this.authService.tryRestoreSession().pipe(
      map(authenticated => {
        if (authenticated) return true
        return this.router.createUrlTree([''], { queryParams: { returnUrl } })
      }),
    )
  }
}
